import React, { useState, useContext } from 'react'
import { Button, Menu, MenuItem } from '@mui/material'
import './Product.css'
import {
    dateTimeFormatFunction,
    handleRedirectInternal,
    capitalize,
} from '@/product/common/components'
import CommonContext from '@/product/context/common/commonContext'
import ReportContext from '@/product/context/report/reportContext'
import { useHistory } from 'react-router-dom'
import { Bar } from 'react-chartjs-2'
import DynamicListing from '../Listing/dynamicListing'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const CatalogView = (props) => {
    const [auctionAnchor, setAuctionAnchor] = useState(null)
    const [photosAnchor, setPhotosAnchor] = useState(null)
    const commonContext = useContext(CommonContext)
    const { getAllExportDownload } = useContext(ReportContext)
    const { setBidHistoryValue } = commonContext
    const history = useHistory()
    const [manage, setManage] = useState({
        popup: false,
        status: '',
        id: 0,
        data: {},
    })
    const handleAuctionClick = (event) => {
        setAuctionAnchor(event.currentTarget)
    }

    const handlePhotosClick = (event) => {
        setPhotosAnchor(event.currentTarget)
    }
    const handleDirection = (data) => {
        handleRedirectInternal(history, `erp/${data}`)
    }

    const handleBid = (id) => {
        setBidHistoryValue({
            id,
            getBidByAuction: true,
            show_tiebid: props.showTieBid || null,
            proxy: props.showProxyBid ? props.showProxyBid : false,
        })
    }

    const toggleFullScreenPopup = (popup, status, id, data) => {
        if (popup) {
            setManage({ popup, status, id, data })
        } else {
            setManage({ popup, status: '', id: 0, data: {} })
        }
    }

    const handleClose = () => {
        setAuctionAnchor(null)
        setPhotosAnchor(null)
    }

    const reportData = {
        labels: ['Bid Price'],
        datasets: [
            {
                label: 'MinBid',
                data: [props.data.min_bid],
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
                label: 'AvgBid',
                data: [props.data.avg_bid],
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
            {
                label: 'MaxBid',
                data: [props.data.max_bid],
                backgroundColor: 'rgba(207,250,171)',
            },
        ],
    }

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Bidding Rate',
            },
        },
    }

    const handleExport = (data) => {
        getAllExportDownload({
            action: 'export',
            order: 'asc',
            orderby: '',
            search: 'all',
            filters: {
                auctionid: {
                    value: data,
                    type: 'in',
                    field: 'p.auctionid',
                },
            },
            report: `single_auction_product_management`,
        })
    }
    const [readMore, setReadMore] = useState(false)
    const [characterLimit, setCharacterLimit] = useState(140)
    const data = props.data
    return (
        <div className="catalogSearchResult">
            <div className="catalogSearchBar cursorDecoy">
                <Bar data={reportData} options={options} />
            </div>
            <div className="catalogSearchContent">
                <div className="catalogSearchBody">
                    <p className="tit">
                        <span>Title:</span>
                        {data.title}
                    </p>
                    <p className="des">
                        <span>Description:</span>
                        <div className="plvDesc">
                            <p className={`${readMore ? 'show' : ''}`}>
                                {data.description.substring(
                                    0,
                                    readMore
                                        ? data.description.length
                                        : characterLimit
                                )}
                                {!readMore &&
                                data.description.length > characterLimit
                                    ? '...'
                                    : null}
                            </p>
                            {data.description.length > characterLimit && (
                                <a
                                    className="readMore cursorDecoy"
                                    onClick={() => setReadMore(!readMore)}
                                >
                                    Read {readMore ? 'less' : 'more'}
                                </a>
                            )}
                        </div>
                    </p>
                    <p className="catalog m-0">
                        <b className="mr-2">Category:</b>
                        {data.category}
                    </p>
                </div>
            </div>
            <figure className="catalogSearchproImg">
                <img
                    src={`${global.images_url}${data.image}`}
                    alt={`${data.title}`}
                />
                <PrimaryButton
                    id="listingDynamic_add"
                    variant="outlined"
                    className="btnOutlined mr-2"
                    onClick={() => toggleFullScreenPopup(true, 'new', 0, data)}
                >
                    <span className="material-icons">add</span>
                    Add Inventory
                </PrimaryButton>
            </figure>
            {manage.popup ? (
                <DynamicListing
                    data={manage}
                    function={toggleFullScreenPopup}
                    cyber={true}
                    insidePage={false}
                />
            ) : null}
        </div>
    )
}

export default CatalogView
